import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { layoutCardRadius, neutral900, white } from '../../theme/colors';

const qtyLabelSx = {
  fontFamily: 'Nunito',
  fontWeight: 700,
  lineHeight: '21px',
  fontSize: '14px',
  color: white,
};

const STEPPER_HEIGHT = {
  sm: '24px',
  md: '32px',
};

const CartQuantityStepper = ({
  cartQuantity,
  onIncrement,
  onDecrement,
  disabledIncrement = false,
  size = 'sm',
  stopPropagation = true,
}) => {
  const stop = (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        height: STEPPER_HEIGHT[size] ?? STEPPER_HEIGHT.sm,
        alignItems: 'center',
        gap: 1,
        borderRadius: layoutCardRadius,
        bgcolor: neutral900,
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      <Button
        variant="quantityStepper"
        data-no-shadow="true"
        onClick={(e) => {
          stop(e);
          onDecrement?.(e);
        }}
        aria-label="Diminuir quantidade"
        sx={{
          p: 0.5,
        }}
      >
        <RemoveIcon sx={{ fontSize: 20, color: 'primary.main'}} />
      </Button>

      <Typography variant="body1" sx={qtyLabelSx}>
        {cartQuantity}
      </Typography>

      <Button
        variant="quantityStepper"
        data-no-shadow="true"
        disabled={disabledIncrement}
        onClick={(e) => {
          stop(e);
          onIncrement?.(e);
        }}
        aria-label="Aumentar quantidade"
        sx={{
          p: 0.5,
        }}
      >
        <AddIcon
          sx={{
            fontSize: 20,
            color: disabledIncrement ? 'text.disabled' : 'primary.main',
          }}
        />
      </Button>
    </Box>
  );
};

export default CartQuantityStepper;
